import React, { useState } from 'react';
import { useTranslate } from 'react-redux-multilingual'
import axios from 'axios'
import swal from "sweetalert2";

const AbonnementCardEditForm = (props) =>{
    const t = useTranslate();
    const [valueInput,setValueInput]=useState({
        date_begin:(props.detailAbonnementCards.date_begin) ? props.detailAbonnementCards.date_begin.split(' ')[0] : '',
        date_end:(props.detailAbonnementCards.date_end) ? props.detailAbonnementCards.date_end.split(' ')[0] : '',
        credit:'',
    }) 
    const [validButton,setValidButton]=useState(false) 

    const handleChange = (e,name) =>{
        if(name=='credit'){
            let montant = e.target.value = e.target.value.replace(/\D/g,'')
            setValueInput({...valueInput,[name]:montant})
        }else{
            setValueInput({...valueInput,[name]:e.target.value})
        }
    }
    
    const submit = async () =>{
        setValidButton(true)
        const response = await axios.post(process.env.REACT_APP_API_URL+"api/pos/abonnement_card/edit_abonnement_card/"+props.detailAbonnementCards.id,{
            date_begin: valueInput.date_begin,
            date_end: valueInput.date_end,
            section: props.posid,
            credit: valueInput.credit,
        }).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
                setValidButton(false)
            }
            else{   
                props.setRelance(Date.now)
                setValueInput({
                    date_begin:'',
                    date_end:'',
                    credit:'',
                })
                props.closeModal()
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
            setValidButton(false)
        })
    }

    return (
        <div>
            <div className='form-group'>
                <label>{t('dateBeginAbonnement')+' :'}</label>
                <input type="date" value={valueInput.date_begin} className='form-control' onChange={(e)=>handleChange(e,'date_begin')}/>
            </div>

            <div className='form-group'>
                <label>{t('dateEndAbonnement')+' :'}</label>
                <input type="date" value={valueInput.date_end} className='form-control' onChange={(e)=>handleChange(e,'date_end')}/>
            </div>

            <div className='form-group'>
                <label>{t('credit')+' :'}</label>
                <input type="text" value={valueInput.credit} className='form-control' onChange={(e)=>handleChange(e,'credit')}/>
            </div>

            <div>
                <button disabled={validButton} className="btn btn-primary mt-3" onClick={()=>submit()}>
                    {validButton ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : t('btnValidate')}
                </button>
            </div>
        </div>
    )
};

export default AbonnementCardEditForm;